import { createSelector } from '@ngrx/store';

import { FUND_CHART_APP_STATE_SLICE_KEY } from 'ChartApp/ts/features/fundamental-chart/constants';
import { TECH_CHART_APP_STATE_SLICE_KEY } from 'ChartApp/ts/features/tech-chart/constants';
import { ChartRootStore, ChartSecurityInfo } from '../interfaces/chart-common.interface';
import { FundChartState } from 'ChartApp/ts/interfaces/fund-chart.interface';
import { TechChartState } from 'ChartApp/ts/interfaces/tech-chart.interface';

export const getAppStateSliceKey = ({
    appStateSliceKey,
}: ChartRootStore): typeof TECH_CHART_APP_STATE_SLICE_KEY | typeof FUND_CHART_APP_STATE_SLICE_KEY => appStateSliceKey;

export const getChartState = ({ appStateSliceKey, ...state }: ChartRootStore): FundChartState | TechChartState =>
    state[appStateSliceKey];

// Securities Info
export const getSecuritiesInfo = ({ securitiesInfo }: ChartRootStore): { [k: string]: ChartSecurityInfo } =>
    securitiesInfo;

export const getSecuritylistSecurityId = createSelector(
    getChartState,
    ({ securitylistSecurityId }) => securitylistSecurityId
);

export const getSecuritylistName = createSelector(getChartState, ({ securitylistName }) => securitylistName);

export const getSecurityGroup = createSelector(getChartState, ({ securityGroup }) => securityGroup);

export const getSelectedSecuritylistItemDisplayId = createSelector(
    getSecuritiesInfo,
    getSecuritylistSecurityId,
    (securitiesInfo, securitylistSecurityId) => {
        if (securitylistSecurityId in securitiesInfo) {
            return securitiesInfo[securitylistSecurityId].display_security_id;
        }
        return 'Loading...';
    }
);
